// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VEmojiPicker from 'v-emoji-picker';
Vue.use (VEmojiPicker);
import store from './store/index';
import 'vue-event-calendar/dist/style.css';
import vueEventCalendar from 'vue-event-calendar';
Vue.use (vueEventCalendar); //可以设置语言，支持中文和英文

import './util/rem';
import Vant from 'vant';
import 'vant/lib/index.css';
// import 'amfe-flexible';
import './css/border.css';
import './css/reset.css';
import './assets/fonts/iconfont.css';
const api = require('@/util/api.js');
Vue.config.productionTip = false;
Vue.use(Vant);
Vue.prototype.$api = api;
Vue.config.productionTip = false;
Vue.use (ElementUI);
/* eslint-disable no-new */
new Vue ({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js